<main id="otp" class="w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    <div class="header-wr">
      <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg"
        [attr.alt]="'LOGIN.LOGO_ALT' | translate" (click)="backToLogin()">
      <h2 class="text-left">{{ 'OTP.OTP_VERIFIED_TITLE' | translate }}</h2>
    </div>
    <div class="form-wr">
      <form (keydown)="submitOnPressEnter($event)">
        <div class="notice text-sm mb-6">
          <p>{{ 'OTP.OTP_VERIFIED_HINT' | translate }}</p>
        </div>
        @if (hasError) {
          <div class="notice error text-sm mb-6">
            <p class="font-semibold">{{ 'OTP.ERROR_HINT_TITLE' | translate }}</p>
            <p>{{ 'OTP.ERROR_GENERIC_MESSAGE' | translate }}</p>
          </div>
        }
        <div class="field-wr">
          <div class="flex items-center justify-between">
            <label for="verification-code" class="block text-sm">{{ 'OTP.VERIFICATION_CODE' | translate }}</label>
          </div>
          <div class="mt-2">
            <input id="verification-code" type="text" name="verification-code"
              placeholder="{{ 'OTP.VERIFICATION_CODE_PLACEHOLDER' | translate }}" maxlength="6"
              [(ngModel)]="verificationCode" required autocomplete="off" class="text-field">
          </div>
        </div>
        <div class="btn-wr mt-5">
          <button id="otp-verify-btn" type="button" class="btn primary-btn w-full" (click)="verify()">{{ 'OTP.BTN_VERIFY' | translate }}</button>
        </div>
      </form>
    </div>
    @if (errorMessage) {
      <div class="notice warning text-sm mt-4">
        <p>{{ errorMessage | translate }}</p>
      </div>
    }
  </div>

</main>
